import { render, staticRenderFns } from "./label_input_item.vue?vue&type=template&id=f40591f2&scoped=true&"
import script from "./label_input_item.vue?vue&type=script&lang=js&"
export * from "./label_input_item.vue?vue&type=script&lang=js&"
import style0 from "./label_input_item.vue?vue&type=style&index=0&id=f40591f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40591f2",
  null
  
)

export default component.exports